import { getApps, initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAeIMzWUV3w1A39AZcV8NxICLlUh5SJLj4",
  authDomain: "smart-school-300211.firebaseapp.com",
  projectId: "smart-school-300211",
  storageBucket: "smart-school-300211.appspot.com",
  messagingSenderId: "429403777394",
  appId: "1:429403777394:web:de06e0f5e50868a38d95eb",
  measurementId: "G-V07WNQQYZQ",
};

// if (!firebase.apps.length) {
//   initializeApp(firebaseConfig);
// } else {
//   app(); // if already initialized, use that one
// }

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
